import TSvgProps from '../types/svgPropsType';

interface IconLinkareerSTEMSymbolProps extends TSvgProps {
  size?: number;
}

const IconLinkareerSTEMSymbol = ({ size = 24, ...rest }: IconLinkareerSTEMSymbolProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M9.83004 5.60645C10.1945 5.60645 10.4923 5.89389 10.4923 6.24504V7.23033H8.64472C8.28023 7.23033 7.98242 6.94289 7.98242 6.59174V5.60645H9.83004Z"
        fill="white"
        stroke="currentColor"
        strokeWidth="1.2"
      />
      <path
        d="M9.36348 1.33032C9.85445 1.33032 10.2564 1.73228 10.2564 2.22324V3.59878H7.76401C7.27305 3.59878 6.87109 3.19683 6.87109 2.70586V1.33032H9.36209H9.36348Z"
        fill="white"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M14.7459 3.59875C14.281 3.59875 13.9004 3.97934 13.9004 4.44421V5.74664H16.2603C16.7252 5.74664 17.1058 5.36606 17.1058 4.90118V3.59875H14.7459Z"
        fill="white"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M12.002 19.4407V3.14551"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.7018 21.4845L13.8731 14.6208V9.39465H10.1275V14.6208L5.29882 21.4845C4.61578 22.4555 4.99508 23.25 6.14336 23.25H17.8573C19.0041 23.25 19.3849 22.4555 18.7018 21.4845Z"
        fill="white"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <rect x="8.50195" y="8.59888" width="7" height="1.5" rx="0.75" fill="currentColor" />
      <path
        d="M11.402 19.4407C11.402 19.7721 11.6706 20.0407 12.002 20.0407C12.3333 20.0407 12.602 19.7721 12.602 19.4407L12.002 19.4407L11.402 19.4407ZM12.002 19.4407L12.602 19.4407L12.602 8.24194L12.002 8.24194L11.402 8.24194L11.402 19.4407L12.002 19.4407Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default IconLinkareerSTEMSymbol;
